<template>
  <div ref="el" class="angled-background" :style="style"></div>
</template>

<script>
import {computed, onMounted, ref} from 'vue'

export default {
  name: 'AngledBackground',

  props: {
    color: {type: String, default: '#3498db'},
    opacity: {type: Number, default: 0.2},

    cut: {type: [String, Number], default: "5%"}
  },

  setup(props) {
    const el = ref(null)
    const pxCut = ref(0)

    const computeCut = () => {
      const rect = el.value.getBoundingClientRect()

      if (typeof props.cut === "string" && props.cut.endsWith("%")) {
        const pct = parseFloat(props.cut) / 100
        pxCut.value = rect.width * pct   // always use width → ensures 45°
      } else if (typeof props.cut === "number") {
        pxCut.value = props.cut
      } else {
        pxCut.value = parseFloat(props.cut)
      }
    }

    onMounted(() => {
      computeCut()
      window.addEventListener("resize", computeCut)
    })

    const style = computed(() => ({
      backgroundColor: props.color,
      opacity: props.opacity,
      clipPath: `
        polygon(
          ${pxCut.value}px 0,
          100% 0,
          100% calc(100% - ${pxCut.value}px),
          calc(100% - ${pxCut.value}px) 100%,
          0 100%,
          0 ${pxCut.value}px
        )
      `
    }))

    return {style, el}
  }
}
</script>

<style scoped>
.angled-background {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: -1;
}
</style>
